// src/utils/markKinds.js — the front-end's view of a mark's KIND.
// ---------------------------------------------------------------------------
// The canonical definition lives in api/shared/mark-catalogue.js. This is the
// browser-side sliver: the three kinds in words a person recognises, plus the
// key suggester. Kept deliberately tiny — the moment real rules live in two
// places they start disagreeing, so validation stays on the server and this is
// only how the choice is PRESENTED.
//
// The kind is not decoration. It decides which tool appears on the plan and the
// unit its totals roll up in, which is what turns a drawing into a take-off.

export const MARK_KINDS_UI = [
  { value: 'pin',    label: 'A point — a pin you drop', unit: 'count' },
  { value: 'area',   label: 'An area — measured in m²', unit: 'm2' },
  { value: 'length', label: 'A run — measured in metres', unit: 'm' },
];

export const UNIT_LABEL = { count: '', m2: 'm²', m: 'm' };

// Suggest a key from a label ("Full regrout" -> "full-regrout"). Only ever used
// when CREATING a type: applying it to an existing one would be a rename, and a
// key can never be renamed — it is what every recorded mark points at.
export function keyFromLabel(label) {
  const k = String(label == null ? '' : label)
    .trim().toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/, '');
  return /^[a-z][a-z0-9-]{0,38}[a-z0-9]$/.test(k) ? k : '';
}
